import React from "react";
import { Col, Row } from "react-bootstrap";

import {
  DiJavascript1,
  
  DiMongodb,
  DiPhp,
  DiMysql,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
 
  SiFirebase,
  SiPostgresql,
  SiKotlin,
} from "react-icons/si";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMysql/>
        </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb/>
        </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPhp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
        </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKotlin />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
     
      </Col>
      
    </Row>
  );
}

export default Techstack;
